// Helper peta khusus voyage (popup gelombang, marker A/B). Nol import biar bisa dites pakai node.

const blank = (value) => value === null || value === undefined || value === '';

export function escapeHtml(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

// Baris popup gelombang; kosong kalau tiga-tiganya gak ada.
export function waveRows(gpsData) {
  const height = gpsData?.waveHeight;
  const period = gpsData?.wavePeriod;
  const seaState = gpsData?.seaState;
  if ([height, period, seaState].every(blank)) return [];

  const fixed = (value, decimals, unit) => {
    if (blank(value) || !Number.isFinite(Number(value))) return '-';
    return `${Number(value).toFixed(decimals)} ${unit}`;
  };

  return [
    { label: 'Wave Height', value: fixed(height, 2, 'm') },
    { label: 'Wave Period', value: fixed(period, 1, 's') },
    { label: 'Sea State', value: blank(seaState) ? '-' : String(seaState) },
  ];
}

// Landmark master voyage -> titik marker A/B yang koordinatnya valid.
export function routeMarkerPoints(origin, destination) {
  return [['A', origin], ['B', destination]].flatMap(([key, landmark]) => {
    if (!landmark || blank(landmark.lndmLatitude) || blank(landmark.lndmLongitude)) return [];
    const lat = Number(landmark.lndmLatitude);
    const lng = Number(landmark.lndmLongitude);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return [];
    return [{
      key,
      lat,
      lng,
      name: landmark.lndmName || '-',
    }];
  });
}
